<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.4422 0.617188H5.56511L0 6.1823V14.0594L5.56511 19.6245H13.4422L19.0074 14.0594V6.1823L13.4422 0.617188ZM9.50368 15.7175C9.23221 15.7175 8.96683 15.637 8.74112 15.4862C8.5154 15.3354 8.33947 15.121 8.23558 14.8702C8.1317 14.6194 8.10452 14.3434 8.15748 14.0772C8.21044 13.8109 8.34116 13.5663 8.53312 13.3744C8.72508 13.1824 8.96965 13.0517 9.2359 12.9987C9.50215 12.9458 9.77813 12.973 10.0289 13.0769C10.2797 13.1807 10.4941 13.3567 10.6449 13.5824C10.7957 13.8081 10.8762 14.0735 10.8762 14.3449C10.8766 14.5253 10.8413 14.7039 10.7724 14.8706C10.7036 15.0373 10.6025 15.1887 10.4749 15.3162C10.3474 15.4437 10.196 15.5448 10.0293 15.6137C9.86264 15.6826 9.68402 15.7178 9.50368 15.7175ZM10.5596 11.1768H8.44776V4.84086H10.5596V11.1768Z"
      fill="#F45484" />
  </svg>
</template>
  
<script>
export default {
  name: "WarningSign",
};
</script>